var map = {
  'AG': true,
  'AW': true,
  'BS': true,
  'BZ': true,
  'BJ': true,
  'BQ': true,
  'BW': true,
  'BF': true,
  'BI': true,
  'CF': true,
  'KM': true,
  'CG': true,
  'CD': true,
  'CK': true,
  'CI': true,
  'CW': true,
  'DJ': true,
  'DM': true,
  'TL': true,
  'GQ': true,
  'ER': true,
  'FJ': true,
  'TF': true,
  'GM': true,
  'GH': true,
  'GD': true,
  'GN': true,
  'GY': true,
  'HK': true,
  'IE': true,
  'KI': true,
  'KP': true,
  'MO': true,
  'MW': true,
  'ML': true,
  'MR': true,
  'MU': true,
  'NR': true,
  'NU': true,
  'QA': true,
  'KN': true,
  'LC': true,
  'ST': true,
  'SC': true,
  'SX': true,
  'SL': true,
  'SB': true,
  'SO': true,
  'SR': true,
  'SY': true,
  'TZ': true,
  'TG': true,
  'TK': true,
  'TO': true,
  'TV': true,
  'UG': true,
  'AE': true,
  'VU': true,
  'YE': true,
  'ZW': true
};

module.exports = map;
